import * as ex from 'excalibur';
import { PlayerUnit } from './playerUnit';

// Player-controlled Dog
export class PlayerDog extends PlayerUnit {
  constructor(options: any) {
    super({
      gridX: options.gridX,
      gridY: options.gridY,
      type: 'dog',
      name: 'Dog',
      color: ex.Color.fromHex('#8B4513'),
      initiative: options.initiative,
      health: 15,
      maxHealth: 15,
      moveRange: 2,
      attackRange: 1,
      abilities: ['bark_push', 'pack_instinct'],
      grid: options.grid
    });

    // Set the emoji for this unit type
    this.setEmoji("🐕"); // Dog emoji
  }
}